export default __webpack_public_path__ + "static/desktop_landing-winter-9189ed45eeb69bcd80c683835091b3e3.png";